import { render, staticRenderFns } from "./Volant.vue?vue&type=template&id=79119f94&"
import script from "./Volant.vue?vue&type=script&lang=js&"
export * from "./Volant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports